import React from "react";
import { Layout } from "antd";
import { any } from "prop-types";

const Content = ({ children }) => {
  return (
    <Layout.Content
      style={{
        maxWidth: "1200px",
        width: "100%",
        margin: "auto"
      }}
    >
      {children}
    </Layout.Content>
  );
};

Content.propTypes = {
  children: any.isRequired
};

export default Content;



// WEBPACK FOOTER //
// ./src/components/content/Content.jsx